import { useEffect } from "react"
import { useAppDispatch } from "../app/hooks";
import { ssoSamlLoginAsync } from "../reducers/login.slice";
import Loader from "./shared/Loader";
import { getAccessToken } from "../utils";
import { useNavigate } from "react-router";
import { getCookieValue, postToNativeApp } from "../common/helpers";
import { CLAIMS, CLAIM_SUBMISSION, ECARD, ENROLLMENT, MEDIBUDDY, NETWORK_HOSPITALS, POLICY_SUMMARY, VENDOR } from "../common/common.constants";

const SSO = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const url = window.location ;    
        const callback = new URLSearchParams(window.location.search).get('RedirectUrl') as string;    
        const token = new URLSearchParams(url.search).get('token') as string || new URLSearchParams(url.search).get('accesstoken') as string || new URLSearchParams(url.search).get('AccessToken') as string;
        if(getAccessToken() && !callback){
            navigate("/")
         }
        const req = { token };
        loginSaml(req,callback)
    }, [])


    const loginSaml = async (req: any,callback:any) => {
        const res = await dispatch(ssoSamlLoginAsync(req))
        if(res && res.payload && res.payload.accessToken){           
              if (callback) {
                switch (callback) { //do not change any of the key names
                    case CLAIMS:
                        navigate('/claim-list', { replace: true });
                        break;
                    case POLICY_SUMMARY:
                        navigate('/policy-list', { replace: true });
                        break;
                    case CLAIM_SUBMISSION:
                        navigate('/claimSubmission/IPD', { replace: true });
                        break;
                    case NETWORK_HOSPITALS:
                        navigate('/hospitals', { replace: true });
                        break;
                    case ECARD:
                            navigate('/', { replace: true ,  state: { fromSSO: true,isEcard :true }});
                            break;
                    case VENDOR:                        
                        navigate('/', {  state: { fromSSO: true,isEkinCare :true }});
                        break;
                    case MEDIBUDDY:
                        navigate('/', {  state: { fromSSO: true,isEkinCare :true }});
                        break;
                        // let url = `https://www.medibuddy.in/sl?cp=AMZ&utm_source=ma_portal&AuthToken=${res?.payload?.accessToken}&MBEntityId=`
                        // if (getCookieValue('source') === 'native') {
                        //     navigate('/', { replace: true });
                        //     postToNativeApp({ "browserUrl": url })
                        //   } else {
                        //     navigate('/', { replace: true });
                        //     window.location.replace(`https://www.medibuddy.in/sl?cp=AMZ&utm_source=ma_portal&AuthToken=${res?.payload?.accessToken}&MBEntityId=`);
                        // }  
                        break;
                    case ENROLLMENT:
                            navigate('/enrollment', { replace: true });
                            break;
                    default:
                        window.location.href = '/';
                        break;
                }
          
            }
            sessionStorage.setItem('userDeviceToken', res.payload?.deviceId);
            postToNativeApp({
                isLinkPolicy:localStorage.getItem('isLinkPolicy') == 'true' ? true : callback ? true: false,
                accessToken: res.payload?.accessToken || null,
                accessTokenExpirationTime: res.payload?.expiry?.toString() || null,
                userDeviceToken: res.payload?.deviceId,
                xRefData: res.payload.xRefData
              });
            if(!callback)
            window.location.reload()
        }else if (res?.payload?.statusCode === 205) {
            window.location.href = '/signup';
        }
    }

    return (
        <>
            <Loader />
        </>
    )
}

export default SSO